export const translations = {
  en: {
    nav: { about: "About", contact: "Contact", talk: "Talk to us" },
    hero: {
      l1: "WE MAKE",
      l2: "THINGS HAPPEN.",
      support: "Business. Sales. Creative. Connections.",
      para: "One trusted point of contact for ideas, opportunities, problems and projects that need to become reality.",
      cta: "Talk to us",
    },
    brief: {
      headline: "How can we help?",
      support: "Describe the problem, opportunity, idea or thing you're looking for.",
      placeholder: "Tell us what you're trying to make happen.",
      guidance: [
        "Tell us a little more.",
        "Give us a bit more context.",
        "What are you trying to solve?",
        "What would you like to make happen?",
      ],
      attach: "Attach a file",
      voice: "Speak",
      listening: "Listening…",
      drop: "Drop to attach",
      uploading: "Uploading…",
      refine: "Refine with AI",
      refining: "Refining…",
      refined: "Refined by AI",
      continue: "Continue",
    },
    intake: {
      intro: "Now tell us a little about your company.",
      q: {
        company: "What is your company name?",
        industry: "What industry or area do you operate in?",
        location: "Where is your company based?",
        website: "Company website, if any?",
        name: "What is your name?",
        role: "What is your role in the company?",
        contact: "How can we best reach you?",
        notes: "Anything else we should know before reviewing your case?",
      },
      next: "Next",
      skip: "Skip",
      send: "Send to Bauhaus",
      sending: "Sending…",
      requireOne: "Add an email or a WhatsApp number.",
      required: "Please fill this in.",
    },
    contact: {
      hint: "Leave an email or WhatsApp so we can reach you.",
      name: "Name",
      company: "Company",
      email: "Email",
      whatsapp: "WhatsApp",
      send: "Send",
      requireOne: "Please add an email or a WhatsApp number.",
      error: "Something went wrong. Please try again.",
      sending: "Sending…",
    },
    final: {
      title: "YOUR PROBLEM HAS BEEN MAPPED.",
      body: "We've organized the information you shared, identified the areas involved and created a business problem brief for our team. Bauhaus will review your case and contact you to discuss the next steps.",
      caseLabel: "CASE",
      cta: "Return to Bauhaus",
    },
    opportunity: {
      title: "A few things may be worth exploring.",
      sub: "We noticed a few adjacent areas — select any that resonate, or simply continue.",
      continueSelected: "Send to Bauhaus",
      continueSkip: "Continue without adding",
    },
    questions: {
      label: "A few quick questions",
      intro: "Just a little more context so we understand you well.",
      done: "Continue",
    },
    about: {
      title: "About",
      body: [
        "Bauhaus Co. is a business house built to connect ideas, people and execution.",
        "We work across business, sales, marketing, communication, creative thinking, technology and connections to help move opportunities forward.",
      ],
    },
    contactPage: {
      title: "Contact",
      email: "contato@bauhausco.com.br",
      whatsapp: "+55 13 99700-3212",
      linkedin: "LinkedIn",
      instagram: "Instagram",
    },
    close: "Close",
  },
  pt: {
    nav: { about: "Sobre", contact: "Contato", talk: "Fale conosco" },
    hero: {
      l1: "NÓS FAZEMOS",
      l2: "ACONTECER.",
      support: "Negócios. Vendas. Criação. Conexões.",
      para: "Um ponto de contato de confiança para ideias, oportunidades, problemas e projetos que precisam se tornar realidade.",
      cta: "Fale conosco",
    },
    brief: {
      headline: "Como podemos ajudar?",
      support: "Descreva o problema, a oportunidade, a ideia ou aquilo que você procura.",
      placeholder: "Conte o que você quer fazer acontecer.",
      guidance: [
        "Conte um pouco mais.",
        "Nos dê um pouco mais de contexto.",
        "O que você está tentando resolver?",
        "O que você gostaria de fazer acontecer?",
      ],
      attach: "Anexar arquivo",
      voice: "Falar",
      listening: "Ouvindo…",
      drop: "Solte para anexar",
      uploading: "Enviando…",
      refine: "Refinar com IA",
      refining: "Refinando…",
      refined: "Refinado por IA",
      continue: "Continuar",
    },
    intake: {
      intro: "Agora conte um pouco sobre a sua empresa.",
      q: {
        company: "Qual é o nome da sua empresa?",
        industry: "Em qual setor ou área você atua?",
        location: "Onde a sua empresa está localizada?",
        website: "Site da empresa, se houver?",
        name: "Qual é o seu nome?",
        role: "Qual é o seu cargo na empresa?",
        contact: "Qual a melhor forma de falar com você?",
        notes: "Há algo mais que devemos saber antes de analisar o seu caso?",
      },
      next: "Próximo",
      skip: "Pular",
      send: "Enviar para a Bauhaus",
      sending: "Enviando…",
      requireOne: "Adicione um email ou um número de WhatsApp.",
      required: "Por favor, preencha este campo.",
    },
    contact: {
      hint: "Deixe um email ou WhatsApp para entrarmos em contato.",
      name: "Nome",
      company: "Empresa",
      email: "Email",
      whatsapp: "WhatsApp",
      send: "Enviar",
      requireOne: "Adicione um email ou um número de WhatsApp.",
      error: "Algo deu errado. Tente novamente.",
      sending: "Enviando…",
    },
    final: {
      title: "SEU PROBLEMA FOI MAPEADO.",
      body: "Organizamos as informações que você compartilhou, identificamos as áreas envolvidas e criamos um brief do problema de negócio para a nossa equipe. A Bauhaus vai analisar o seu caso e entrar em contato para discutir os próximos passos.",
      caseLabel: "CASO",
      cta: "Voltar para a Bauhaus",
    },
    opportunity: {
      title: "Algumas coisas podem valer a pena explorar.",
      sub: "Percebemos algumas áreas adjacentes — selecione as que fizerem sentido, ou apenas continue.",
      continueSelected: "Enviar para a Bauhaus",
      continueSkip: "Continuar sem adicionar",
    },
    questions: {
      label: "Algumas perguntas rápidas",
      intro: "Só um pouco mais de contexto para entendermos você bem.",
      done: "Continuar",
    },
    about: {
      title: "Sobre",
      body: [
        "A Bauhaus Co. é uma casa de negócios criada para conectar ideias, pessoas e execução.",
        "Atuamos em negócios, vendas, marketing, comunicação, pensamento criativo, tecnologia e conexões para fazer as oportunidades avançarem.",
      ],
    },
    contactPage: {
      title: "Contato",
      email: "contato@bauhausco.com.br",
      whatsapp: "+55 13 99700-3212",
      linkedin: "LinkedIn",
      instagram: "Instagram",
    },
    close: "Fechar",
  },
};
